import { FC } from 'react';
import styled from 'styled-components';
import { GenericContainerCard, SideSpace } from '../UtilitiesMatchMobile/GenericCssComponentMatchMobile';
import CenterInfoFightRendering from '../UtilitiesMatchMobile/GenericRendering/CenterInfoFightRendering';
import RenderTeamWhenThreeTeamsInSpace from './RenderWrestlerBySpaceAndNumber/RenderTeam/RenderTeamWhenThreeTeamsInSpace';
import RenderingMatchWithConditionExtended from '../UtilitiesMatchMobile/RenderingMatchWithConditionExtended';
import { Match, WrestlerInMatch } from '../../../../types';


export const WrapperSideSpace = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;

interface SixTagMatchRenderProps {
    matchInfo: Match;
    withWinner?: boolean;
    isExpanded?: boolean;
}

interface WrestlerWithTeam extends WrestlerInMatch {
    team?: number;
}

const SixTagMatchRender: FC<SixTagMatchRenderProps> = ({ matchInfo, withWinner = false, isExpanded = false }) => {
    // wrestlers1 sono i matchinfo.wrestlers con team 1
    // wrestlers2 sono i matchinfo.wrestlers con team 2
    const team1 = matchInfo.wrestlers.filter((wrestler: WrestlerWithTeam) => wrestler.team === 1);
    const team2 = matchInfo.wrestlers.filter((wrestler: WrestlerWithTeam) => wrestler.team === 2);
    const team3 = matchInfo.wrestlers.filter((wrestler: WrestlerWithTeam) => wrestler.team === 3);
    const team4 = matchInfo.wrestlers.filter((wrestler: WrestlerWithTeam) => wrestler.team === 4);
    const team5 = matchInfo.wrestlers.filter((wrestler: WrestlerWithTeam) => wrestler.team === 5);
    const team6 = matchInfo.wrestlers.filter((wrestler: WrestlerWithTeam) => wrestler.team === 6);

    function renderGenericContainerCard() {
        return (
            <GenericContainerCard className='six-tag-match-render'
            height={isExpanded ? '80%' : '100%'}
            >
                <SideSpace className='side-space'>

                    <WrapperSideSpace className='wrapper-side-space'>
                        <RenderTeamWhenThreeTeamsInSpace team={team1} side='left' withWinner={withWinner} />
                        <RenderTeamWhenThreeTeamsInSpace team={team2} side='left' withWinner={withWinner} />
                        <RenderTeamWhenThreeTeamsInSpace team={team3} side='left' withWinner={withWinner} />
                    </WrapperSideSpace>

                </SideSpace>
                <CenterInfoFightRendering matchInfo={matchInfo} typeMatch='Six-Tag' />
                <SideSpace className='side-space'>

                    <WrapperSideSpace className='wrapper-side-space'>
                        <RenderTeamWhenThreeTeamsInSpace team={team4} side='right' withWinner={withWinner} />
                        <RenderTeamWhenThreeTeamsInSpace team={team5} side='right' withWinner={withWinner} />
                        <RenderTeamWhenThreeTeamsInSpace team={team6} side='right' withWinner={withWinner} />
                    </WrapperSideSpace>

                </SideSpace>
            </GenericContainerCard>
        )
    }

    return (
        RenderingMatchWithConditionExtended({ renderGenericContainerCard, isExpanded, matchInfo })
    )
}

export default SixTagMatchRender;
